import HeroMess from '../../../assets/images/landing-page/hero-mess-exact-clean.png'
import TechnologyForMarketing from '../../../assets/images/landing-page/technology-for-marketing.png'
import DigitalLeaders from '../../../assets/images/landing-page/digital-leaders.png'
import Nvidia from '../../../assets/images/landing-page/nvidia.png'
import LawtechUK from '../../../assets/images/landing-page/lawtechuk.png'
import MinistryOfJustice from '../../../assets/images/landing-page/ministry-of-justice.png'
import ContentAuthenticityInitiative from '../../../assets/images/landing-page/content-authenticity-initiative.png'
import C2PA from '../../../assets/images/landing-page/c2pa.png'
import { bookEnterpriseMeeting } from '../../../utils/Helper'

const PARTNER_LOGOS = [
  {
    src: TechnologyForMarketing,
    alt: 'Technology for Marketing',
    className: 'technology-for-marketing',
  },
  {
    src: DigitalLeaders,
    alt: 'Digital Leaders',
    className: 'digital-leaders',
  },
  {
    src: Nvidia,
    alt: 'NVIDIA Inception Program',
    className: 'nvidia',
  },
  {
    src: LawtechUK,
    alt: 'LawtechUK',
    className: 'lawtechuk',
  },
  {
    src: MinistryOfJustice,
    alt: 'Ministry of Justice',
    className: 'ministry-of-justice',
  },
  {
    src: ContentAuthenticityInitiative,
    alt: 'Content Authenticity Initiative',
    className: 'content-authenticity-initiative',
  },
  {
    src: C2PA,
    alt: 'C2PA',
    className: 'c2pa',
  },
]

const Banner = ({ setIsSignUpOpen }) => {
  return (
    <section className="tikbox-banner tikbox-banner--refresh">

      <div className="tikbox-banner__hero">

        <div className="tikbox-banner__hero-inner">

          <div className="tikbox-banner__copy">

            <p className="tikbox-banner__eyebrow">
              RIGHTS. IN CONTEXT. IN FLOW.
            </p>

            <h1 className="banner-title">
              Digital content<br />
              in the age of AI is a mess.
              <span>We’re sorting it out.</span>
            </h1>

            <p className="tikbox-banner__support">
              Know which rules apply. Then turn them into permissions, provenance, disclosures and controls that travel with your content - so it can be used with confidence, governed responsibly, and valued on clearer terms.
              {/* Bring policies, permissions, provenance and transparency into
              your existing workflows – so content can be used with confidence,
              governed responsibly and valued on clearer terms. */}
            </p>

            <div className="tb-button-group tikbox-banner__actions">

              <button
                className="tb-btn tb-btn--primary-inverse"
                onClick={bookEnterpriseMeeting}
              >
                Book a readiness review
              </button>

              <button
                className="tb-btn tb-btn--secondary-inverse"
                onClick={() => setIsSignUpOpen(true)}
              >
                START FOR FREE
              </button>

            </div>

          </div>


          <div
            className="tikbox-banner__flow"
            role="img"
            aria-label="Trust erosion, copyright infringement, deepfakes, regulatory risk and revenue loss are shown around a tangled line that resolves into TikBox."
          >

            <img
              className="tikbox-banner__mess"
              src={HeroMess}
              alt=""
            />

            <span
              className="
                tikbox-banner__risk
                tikbox-banner__risk--trust
              "
            >
              Trust erosion
            </span>

            <span
              className="
                tikbox-banner__risk
                tikbox-banner__risk--copyright
              "
            >
              Copyright infringement
            </span>

            <span
              className="
                tikbox-banner__risk
                tikbox-banner__risk--deepfakes
              "
            >
              Deepfakes
            </span>

            <span
              className="
                tikbox-banner__risk
                tikbox-banner__risk--regulatory
              "
            >
              Regulatory risk
            </span>

            <span
              className="
                tikbox-banner__risk
                tikbox-banner__risk--revenue
              "
            >
              Revenue loss
            </span>

            {/* <span className="tikbox-banner__solution-line" /> */}

            <div className="tikbox-banner__tikbox-mark">
              TikBox
            </div>

          </div>

        </div>

      </div>


      <div className="tikbox-banner__recognition">

        <p className="tikbox-banner__recognition-title">
          Partnerships and Recognition
        </p>

        <div className="tikbox-banner__logos">

          {PARTNER_LOGOS.map((logo) => (
            <div
              className="tikbox-banner__logo"
              key={logo.alt}
            >
              <img
                className={`
                  tikbox-banner__logo-img
                  tikbox-banner__logo-img--${logo.className}
                `}
                src={logo.src}
                alt={logo.alt}
              />
            </div>
          ))}

        </div>

      </div>

    </section>
  )
}

export default Banner